import styled from "styled-components";

// Shared pill shape for small status/type indicators (e.g. Due Diligence
// case status, contract variant). Domain-specific coloring is layered on
// top via `styled(Badge)` so every badge across the app shares the same
// shape/typography instead of re-declaring it per feature.
export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.625rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  font-weight: 500;
  border: 1px solid transparent;
  background-color: #F3F4F6;
  color: #6B7280;
`;
